export default "__VITE_ASSET__DGCCW8Wt__"